import { Action } from '@ngrx/store';
import { ContentDocumentLink } from 'src/app/models/content-document-link.model';

// load invoice attachments
export const LOAD_INVOICE_ATTACHMENTS =
  '[Invoice Attachments] Load Invoice Attachments';
export const LOAD_INVOICE_ATTACHMENTS_FAIL =
  '[Invoice Attachments] Load Invoice Attachments Fail';
export const LOAD_INVOICE_ATTACHMENTS_SUCCESS =
  '[Invoice Attachments] Load Invoice Attachments Success';
export const CLEAR_INVOICE_ATTACHMENTS =
  '[Invoice Attachments] Clear Invoice Attachments';

export class LoadInvoiceAttachments implements Action {
  readonly type = LOAD_INVOICE_ATTACHMENTS;
}

export class LoadInvoiceAttachmentsFail implements Action {
  readonly type = LOAD_INVOICE_ATTACHMENTS_FAIL;
  constructor(public payload: any) {}
}

export class LoadInvoiceAttachmentsSuccess implements Action {
  readonly type = LOAD_INVOICE_ATTACHMENTS_SUCCESS;
  constructor(public payload: ContentDocumentLink[]) {}
}

export class ClearInvoiceAttachments implements Action {
  readonly type = CLEAR_INVOICE_ATTACHMENTS;
}

// action types
export type InvoiceAttachmentsAction =
  | LoadInvoiceAttachments
  | LoadInvoiceAttachmentsFail
  | LoadInvoiceAttachmentsSuccess
  | ClearInvoiceAttachments;
